module.exports = __webpack_public_path__ + "img/banner_1.20063f80.jpg";